import Tabs from '@material-ui/core/Tabs'

export default Tabs
